let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJVN1")).then(() => parcelRequire('5ARi3'));